(function () {
  function initGallery(gallery) {
    var heroItems = gallery.querySelectorAll('.product-gallery__hero-item');
    var thumbs = gallery.querySelectorAll('.product-gallery__thumb');
    var thumbsContainer = gallery.querySelector('.product-gallery__thumbs');
    var prevArrow = gallery.querySelector('.product-gallery__arrow--prev');
    var nextArrow = gallery.querySelector('.product-gallery__arrow--next');

    if (heroItems.length <= 1) return;

    /* ── Thumbnail click → swap hero ── */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.dataset.index, 10);

        /* Update hero items */
        heroItems.forEach(function (item) {
          item.classList.remove('is-active');
        });
        var target = gallery.querySelector('.product-gallery__hero-item[data-index="' + index + '"]');
        if (target) target.classList.add('is-active');

        /* Update thumbnail active state */
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');

        /* Pause any playing media */
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        /* Load deferred media (video/3D) if present */
        if (target) {
          var deferred = target.querySelector('.deferred-media');
          if (deferred && typeof deferred.loadContent === 'function') {
            deferred.loadContent(false);
          }
        }
      });
    });

    /* ── Scroll arrows ── */
    if (!thumbsContainer || !prevArrow || !nextArrow) return;

    var scrollAmount = 200;

    function updateArrows() {
      var scrollLeft = thumbsContainer.scrollLeft;
      var maxScroll = thumbsContainer.scrollWidth - thumbsContainer.clientWidth;

      prevArrow.disabled = scrollLeft <= 2;
      nextArrow.disabled = scrollLeft >= maxScroll - 2;
    }

    prevArrow.addEventListener('click', function () {
      thumbsContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextArrow.addEventListener('click', function () {
      thumbsContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    thumbsContainer.addEventListener('scroll', updateArrows);
    updateArrows();

    /* ── Hero click → open modal at active media only ── */
    var sectionId = gallery.id.replace('ProductGallery-', '');
    var modal = document.getElementById('ProductModal-' + sectionId);

    if (modal) {
      /* Observe modal open to show only the active media */
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'open' && modal.hasAttribute('open')) {
            var activeHero = gallery.querySelector('.product-gallery__hero-item.is-active');
            if (!activeHero) return;

            /* Get the active media's Shopify media ID from data-media-id */
            var activeMediaId = activeHero.dataset.mediaId;
            if (!activeMediaId) return;
            /* Strip section prefix if present (format: "sectionId-mediaId") */
            var mediaId = activeMediaId.replace(sectionId + '-', '');

            /* Show only the active media in modal, hide all others */
            modal.querySelectorAll('[data-media-id]').forEach(function (el) {
              if (el.getAttribute('data-media-id') === mediaId) {
                el.classList.add('active');
                el.style.display = '';
              } else {
                el.classList.remove('active');
                el.style.display = 'none';
              }
            });
          }
        });
      });
      observer.observe(modal, { attributes: true });

      /* Restore all media when modal closes */
      document.body.addEventListener('modalClosed', function () {
        modal.querySelectorAll('[data-media-id]').forEach(function (el) {
          el.style.display = '';
        });
      });
    }

    /* Re-check arrows after images load (may change scrollWidth) */
    var thumbImages = thumbsContainer.querySelectorAll('img');
    var loaded = 0;
    thumbImages.forEach(function (img) {
      if (img.complete) {
        loaded++;
        if (loaded === thumbImages.length) updateArrows();
      } else {
        img.addEventListener('load', function () {
          loaded++;
          if (loaded === thumbImages.length) updateArrows();
        });
      }
    });
  }

  /* ── Boot ── */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-gallery').forEach(initGallery);
  });
})();
